<template lang="pug">
.m-card
  .m-card-header(:id="'heading-htftoe-' + id" :data-bs-target="'#collapse-htftoe-' + id" :aria-controls="'collapse-htftoe-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_HTFTOE", 1) }}
  .m-card-body.collapse.show(:id="'collapse-htftoe-' + id" :aria-labelledby="'heading-htftoe-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            .col
              template(v-for="item in col1")
                template(v-if="moreItems['htftoeo'][item] && moreItems['htftoeo'][item][5] != 0 && moreItems['htftoeo'][item][5] != ''")
                  OddsItem(:odds="moreItems['htftoeo'][item]" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BK_' + item)")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in col2")
                template(v-if="moreItems['htftoeo'][item] && moreItems['htftoeo'][item][5] != 0 && moreItems['htftoeo'][item][5] != ''")
                  OddsItem(:odds="moreItems['htftoeo'][item]" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BK_' + item)")
                template(v-else)
                  OddsDisabled

//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-htftoe-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-htftoe-' + id"
//-     :aria-controls="'collapse-htftoe-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_HTFTOE") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-htftoe-' + id"
//-     :id="'collapse-htftoe-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BK_" + item) }}
//-               template(v-if="moreItems['htftoeo'][item] && moreItems['htftoeo'][item][5] != 0 && moreItems['htftoeo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['htftoeo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="htftoeo")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col1: ["OO", "OE"],
      col2: ["EO", "EE"],
    }
  }
}
</script>
